import { create } from "zustand";

const useTaskStore = create((set) => ({
  taskId: null,
  taskList: null,
  selectedTask: null,
  addressData: null,
  setTaskId: (value) => set((state) => ({...state, taskId: value, selectedTask: state.taskList?.find(x => x.task_id === value)})),
  setTaskList: (value) => set((state) => ({...state, taskList: value, selectedTask: value?.find(x => x.task_id === state.taskId)})),
  setAddressData: (value) => set((state) => ({...state, addressData: value})),
  updateSelected: () => set((state) => ({...state})),
}));

export default useTaskStore;
